<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order No：{{ formData.orderNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.orderStatus === 'Y' ||
            formData.orderStatus === 'P' ||
            formData.orderStatus === 'C'
              ? 'success'
              : formData.orderStatus === 'S'
              ? 'warning'
              : formData.orderStatus === 'D' ||
                formData.orderStatus === 'R' ||
                formData.orderStatus === 'T'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_orderStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_sales_person') || '业务人员'
            "
          >
            <el-input v-model="formData.salesPersonName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_biz_person') || '跟单人员'
            "
          >
            <el-input v-model="formData.bizPersonName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_production_order_type') || '订单类型'"
          >
            <el-input v-model="formData.v_orderType" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_source') || '订单来源'
            "
          >
            <el-input v-model="formData.v_orderSource" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_issue_yype') || '下单方式'
            "
            prop="issueType"
          >
            <el-input v-model="formData.v_issueType" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_sales_season') || '销售季节'
            "
          >
            <el-input v-model="formData.v_salesSeason" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_customer') || '下单客户'
            "
            prop="custCode"
          >
            <el-input v-model="formData.custName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_custOrderNo') ||
                '客户订单编号'
            "
            prop="custOrderNo"
          >
            <el-input v-model="formData.custOrderNo" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_identify_no') || '识别单号'
            "
          >
            <el-input v-model="formData.identifyNo" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_customer_comfirm_time') ||
                '客户下单日期'
            "
          >
            <el-input
              v-model="formData.customerComfirmTime"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_end_customer') || '终端客户'
            "
          >
            <el-input v-model="formData.endCustName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_production_order_brand') || '品牌'"
          >
            <el-input v-model="formData.brandName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_brand_department') ||
                '品牌方部门'
            "
          >
            <el-input v-model="formData.brandDepartment" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_delivery_day') || '交货日期'
            "
          >
            <el-input v-model="formData.deliveryDay" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_shipment_type') ||
                '出运方式'
            "
          >
            <el-input v-model="formData.v_shipmentType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_delivery_port') ||
                '交货港口'
            "
          >
            <el-input v-model="formData.v_deliveryPort" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_delivery_address') ||
                '交货地址'
            "
          >
            <el-input v-model="formData.deliveryAddress" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_amount') || '订单成本总价'
            "
          >
            <el-input v-model="formData.v_orderAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_currency_unit') ||
                '成本货币单位'
            "
          >
            <el-input v-model="formData.v_currencyUnit" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_importance_level') ||
                '订单性质'
            "
          >
            <el-input v-model="formData.v_importanceLevel" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_importance_level_desc') ||
                '订单性质说明'
            "
          >
            <el-input
              v-model="formData.importanceLevelDesc"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_remark') || '订单备注说明'
            "
          >
            <el-input
              v-model="formData.orderRemark"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Submit：{{ formData.submitByName || '--' }} at
          {{ formData.submitTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName || '--' }} at
          {{ formData.reviewTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { orderCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.$api
        .pendingOrderDetailApi({
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
